import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "loading",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/loading.vue")
  },
  {
    path: "/index1",
    name: "index1",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue")
  },
];

const router = new VueRouter({
  routes
});

export default router;
